import { Component, inject, Input } from '@angular/core';
import { AtAGlanceNotification } from '@models';
import { StudyService } from '@services';

@Component({
  selector: 'at-a-glance',
  templateUrl: './at-a-glance.component.html',
  styleUrls: ['./at-a-glance.component.scss']
})
export class AtAGlanceComponent {
  private studyService = inject(StudyService);
  @Input() notifications: AtAGlanceNotification[] = [];
  infoTooltipOpen = false;
  readonly infoTooltipText = 'Tooltip info coming soon.';

  get showClientName(): boolean {
    return this.studyService.getParentClientNames().length > 1;
  }
  trackByStudySk(index: number, item: AtAGlanceNotification): string {
    const compositeKey = `${item.studySk}|${item.notificationType}|${item.date}`;
    return compositeKey !== '||' ? compositeKey : `index-${index}`;
  }

  onInfoEnter(): void {
    this.infoTooltipOpen = true;
  }

  onInfoLeave(): void {
    this.infoTooltipOpen = false;
  }

  onInfoToggle(): void {
    this.infoTooltipOpen = !this.infoTooltipOpen;
  }
}
